/* eslint-disable @typescript-eslint/no-inferrable-types */
/**
 * システム取込項目名
 */
// サプライヤ商品コード
export const ID_NUMBER: string = 'id_number';
// CAS
export const CAS: string  = 'cas_number';
// MDL
export const MDL: string  = 'mdl_number';
// 化学名１
export const NAME1: string  = 'name1';
// 化学名２
export const NAME2: string  = 'name2';
// 純度
export const PURITY: string  = 'purity';
// 保管
export const STORAGE: string  = 'storage';
// 危険情報
export const HAZARD_INFORMATION: string  = 'hazard_info';
// 溶解度
export const SOLUBILITY: string  = 'solubility';
// 対象
export const TARGET: string  = 'target';
// 備考
export const NOTE: string  = 'memo';
// URL
export const SUPPLIER_URL: string  = 'url';
// CoA
export const COA: string  = 'coa';

// システム取込項目名
export const SystemImportItemName: { [index: string]: string } = {
  [ID_NUMBER]: 'サプライヤ商品コード',
  [CAS]: 'CAS No.',
  [MDL]: 'MDL',
  [NAME1]: '化学名１',
  [NAME2]: '化学名２',
  [PURITY]: 'Purity',
  [STORAGE]: 'Storage',
  [HAZARD_INFORMATION]: 'Hazard Information',
  [SOLUBILITY]: 'Solubility',
  [TARGET]: 'Target',
  [NOTE]: '備考',
  [SUPPLIER_URL]: 'Supplier URL',
  [COA]: 'CoA',
};

// システム取込項目名コード
const SystemImportItemCode: { [index: string]: string } = {
  [ID_NUMBER]: '1',
  [CAS]: '2',
  [MDL]: '3',
  [NAME1]: '4',
  [NAME2]: '5',
  [PURITY]: '6',
  [STORAGE]: '7',
  [HAZARD_INFORMATION]: '8',
  [SOLUBILITY]: '9',
  [TARGET]: 'A',
  [NOTE]: 'B',
  [SUPPLIER_URL]: 'C',
  [COA]: 'D',
};

export default SystemImportItemCode;
